import React, { useState } from 'react';
import Home from './Home'
import About from './About'
import NotFound from './NotFound'

const handleRender = (e, props) => {
    let exp = Math.floor(Math.random() * props);
    console.log(exp);
    return exp;
  };
  function Test(exp) {
    switch (exp) {
      case 1:
        return <About />;
      case 2:
        return <Home />;
      default:
        return <NotFound />;
    }
  }
  function Play() {
    const [exp, setExp] = useState(0);
    return (
      <div className="App">
        <button onClick={() => setExp(handleRender('a', '5'))}>
          Render One Two or Three
        </button>
        {Test(exp)}
      </div>
    );
  }

  export default Play;